import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'retirement',
  template: require('./retirement.component.html')
})
export class RetirementComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  updateOptionValue(event) { }

  helpMeDecide(event: any) {
    this.modal.questionnaire();
  }

  btnClick(e) {
    this.handleClick(e.action);
  }
}
